import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { Users2 } from 'lucide-react'

export default function TeamMembersPlaceholder() {
  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-5xl mx-auto space-y-6">
        <header className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Users2 className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-foreground">Manage team members</h1>
            <p className="text-muted-foreground">The full members grid and modals will be migrated next.</p>
          </div>
        </header>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle>Next steps</CardTitle>
            <CardDescription>
              Port `TeamMembersList`, `AddMemberModal`, and related hooks to restore the interactive roster experience here.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button asChild>
              <Link to="/dashboard/team">Back to team dashboard</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
